// ترجمه‌ی پوسته‌ی اصلی پنل مدیریت (AdminDashboard.jsx): عنوان اپ، نقش‌ها،
// دکمه خروج، و برچسب تمام گروه‌ها/آیتم‌های منو.
export default {
  fa: {
    appTitle: 'جامعه پاترهدها',
    dashboardFallback: 'داشبورد',
    adminRole: 'ادمین',
    teacherRole: 'استاد',
    logout: 'خروج از حساب',
    brand: 'هاگوارتز',
    groups: {
      'dashboard-group': 'داشبورد و آنالیتیکس',
      'users-group': 'کاربران و دسترسی‌ها',
      'game-group': 'بازی و ماجراجویی',
      'diagon-alley-group': 'کوچه دیاگون',
      'content-group': 'ارتباطات و محتوا',
      'support-group': 'پشتیبانی و بازخورد',
      'monitoring-group': 'مانیتورینگ و لاگ‌ها',
      'system-group': 'تنظیمات سیستم',
    },
    items: {
      dashboard: 'داشبورد',
      analytics: 'آنالیتیکس بازدید',
      'security-logs': 'فعالیت‌های مشکوک',
      users: 'کاربران',
      waitlist: 'لیست انتظار',
      invitations: 'دعوت‌نامه‌ها',
      teachers: 'مدیریت اساتید',
      'devices-blacklist': 'دستگاه‌ها و لیست سیاه',
      'change-password': 'تغییر رمز عبور',
      'game-steps': 'مراحل بازی',
      train: 'قطار هاگوارتز',
      'train-schedules': 'زمان‌های حرکت قطار',
      requirements: 'وسایل مدرسه',
      'year-game': 'بازی سالانه',
      'game-missions': 'ماموریت‌های بازی سالانه',
      persons: 'Journey / Tag',
      'test-results': 'نتایج آزمون‌ها',
      'diagon-alley': 'مدیریت کوچه دیاگون',
      'landing-content': 'محتوای صفحه اصلی',
      'about-content': 'محتوای صفحه مراحل بازی',
      faq: 'سوالات متداول (FAQ)',
      'journey-video': 'ویدیوی ابتدای سفر',
      'site-nav': 'منوی هدر/فوتر',
      'sms-templates': 'الگوهای SMS',
      'site-messages': 'پیام‌های سایت',
      blog: 'مدیریت مقالات',
      'forum-moderation': 'نظارت بر فروم',
      'support-tickets': 'صندوق جغدی (پشتیبانی)',
      'contact-messages': 'پیام‌های تماس',
      'feature-requests': 'درخواست‌های ویژگی',
      'error-monitor': 'مانیتورینگ خطاها',
      'request-logs': 'درخواست‌های سرور',
      'gringotts-bank': 'بانک گرینگوتز',
      'chat-logs': 'گفتگوهای دامبلدور',
      transactions: 'دفتر تراکنش‌ها',
      'sms-logs': 'لاگ پیامک‌ها',
      'registration-settings': 'تنظیمات عمومی',
      'languages-settings': 'تنظیمات زبان‌ها/ساب‌دامنه‌ها',
      'ai-settings': 'تنظیمات هوش مصنوعی',
      'payment-settings': 'تنظیمات پرداخت',
      'sms-settings': 'تنظیمات SMS',
      'email-settings': 'تنظیمات ایمیل',
      'telegram-bot': 'ربات تلگرام',
      'birthday-settings': 'تنظیمات تبریک تولد',
      backup: 'بکاپ دیتابیس',
      'analytics-tracking': 'تگ منیجر/آنالیتیکس',
    },
  },
  en: {
    appTitle: 'Potterheads Community',
    dashboardFallback: 'Dashboard',
    adminRole: 'Admin',
    teacherRole: 'Teacher',
    logout: 'Log Out',
    brand: 'Hogwarts',
    groups: {
      'dashboard-group': 'Dashboard & Analytics',
      'users-group': 'Users & Access',
      'game-group': 'Game & Adventure',
      'diagon-alley-group': 'Diagon Alley',
      'content-group': 'Communication & Content',
      'support-group': 'Support & Feedback',
      'monitoring-group': 'Monitoring & Logs',
      'system-group': 'System Settings',
    },
    items: {
      dashboard: 'Dashboard',
      analytics: 'Visit Analytics',
      'security-logs': 'Suspicious Activity',
      users: 'Users',
      waitlist: 'Waitlist',
      invitations: 'Invitations',
      teachers: 'Teachers Management',
      'devices-blacklist': 'Devices & Blacklist',
      'change-password': 'Change Password',
      'game-steps': 'Game Steps',
      train: 'Hogwarts Express',
      'train-schedules': 'Train Schedules',
      requirements: 'School Supplies',
      'year-game': 'Yearly Game',
      'game-missions': 'Yearly Game Missions',
      persons: 'Journey / Tag',
      'test-results': 'Test Results',
      'diagon-alley': 'Diagon Alley Management',
      'landing-content': 'Homepage Content',
      'about-content': 'Journey Page Content',
      faq: 'FAQ',
      'journey-video': 'Journey Intro Video',
      'site-nav': 'Header/Footer Menu',
      'sms-templates': 'SMS Templates',
      'site-messages': 'Site Messages',
      blog: 'Blog Management',
      'forum-moderation': 'Forum Moderation',
      'support-tickets': 'Owl Post (Support)',
      'contact-messages': 'Contact Messages',
      'feature-requests': 'Feature Requests',
      'error-monitor': 'Error Monitor',
      'request-logs': 'Server Requests',
      'gringotts-bank': 'Gringotts Bank',
      'chat-logs': 'Dumbledore Chats',
      transactions: 'Transaction Ledger',
      'sms-logs': 'SMS Logs',
      'registration-settings': 'General Settings',
      'languages-settings': 'Languages/Subdomains Settings',
      'ai-settings': 'AI Settings',
      'payment-settings': 'Payment Settings',
      'sms-settings': 'SMS Settings',
      'email-settings': 'Email Settings',
      'telegram-bot': 'Telegram Bot',
      'birthday-settings': 'Birthday Greeting Settings',
      backup: 'Database Backup',
      'analytics-tracking': 'Tag Manager/Analytics',
    },
  },
  de: {
    appTitle: 'Potterheads-Gemeinschaft',
    dashboardFallback: 'Dashboard',
    adminRole: 'Admin',
    teacherRole: 'Lehrer',
    logout: 'Abmelden',
    brand: 'Hogwarts',
    groups: {
      'dashboard-group': 'Dashboard & Analytik',
      'users-group': 'Benutzer & Zugriff',
      'game-group': 'Spiel & Abenteuer',
      'diagon-alley-group': 'Winkelgasse',
      'content-group': 'Kommunikation & Inhalte',
      'support-group': 'Support & Feedback',
      'monitoring-group': 'Überwachung & Protokolle',
      'system-group': 'Systemeinstellungen',
    },
    items: {
      dashboard: 'Dashboard',
      analytics: 'Besuchsanalyse',
      'security-logs': 'Verdächtige Aktivitäten',
      users: 'Benutzer',
      waitlist: 'Warteliste',
      invitations: 'Einladungen',
      teachers: 'Lehrerverwaltung',
      'devices-blacklist': 'Geräte & Sperrliste',
      'change-password': 'Passwort ändern',
      'game-steps': 'Spielschritte',
      train: 'Hogwarts-Express',
      'train-schedules': 'Zugfahrpläne',
      requirements: 'Schulbedarf',
      'year-game': 'Jahresspiel',
      'game-missions': 'Missionen des Jahresspiels',
      persons: 'Journey / Tag',
      'test-results': 'Testergebnisse',
      'diagon-alley': 'Winkelgassen-Verwaltung',
      'landing-content': 'Startseiteninhalt',
      'about-content': 'Inhalt der Journey-Seite',
      faq: 'Häufige Fragen (FAQ)',
      'journey-video': 'Einführungsvideo',
      'site-nav': 'Header/Footer-Menü',
      'sms-templates': 'SMS-Vorlagen',
      'site-messages': 'Website-Nachrichten',
      blog: 'Blogverwaltung',
      'forum-moderation': 'Forenmoderation',
      'support-tickets': 'Eulenpost (Support)',
      'contact-messages': 'Kontaktnachrichten',
      'feature-requests': 'Funktionswünsche',
      'error-monitor': 'Fehlerüberwachung',
      'request-logs': 'Serveranfragen',
      'gringotts-bank': 'Gringotts-Bank',
      'chat-logs': 'Dumbledore-Chats',
      transactions: 'Transaktionsbuch',
      'sms-logs': 'SMS-Protokolle',
      'registration-settings': 'Allgemeine Einstellungen',
      'languages-settings': 'Sprachen-/Subdomain-Einstellungen',
      'ai-settings': 'KI-Einstellungen',
      'payment-settings': 'Zahlungseinstellungen',
      'sms-settings': 'SMS-Einstellungen',
      'email-settings': 'E-Mail-Einstellungen',
      'telegram-bot': 'Telegram-Bot',
      'birthday-settings': 'Geburtstagsgrüße-Einstellungen',
      backup: 'Datenbank-Backup',
      'analytics-tracking': 'Tag Manager/Analytik',
    },
  },
  es: {
    appTitle: 'Comunidad Potterheads',
    dashboardFallback: 'Panel',
    adminRole: 'Admin',
    teacherRole: 'Profesor',
    logout: 'Cerrar sesión',
    brand: 'Hogwarts',
    groups: {
      'dashboard-group': 'Panel y análisis',
      'users-group': 'Usuarios y accesos',
      'game-group': 'Juego y aventura',
      'diagon-alley-group': 'Callejón Diagon',
      'content-group': 'Comunicación y contenido',
      'support-group': 'Soporte y comentarios',
      'monitoring-group': 'Monitoreo y registros',
      'system-group': 'Configuración del sistema',
    },
    items: {
      dashboard: 'Panel',
      analytics: 'Análisis de visitas',
      'security-logs': 'Actividad sospechosa',
      users: 'Usuarios',
      waitlist: 'Lista de espera',
      invitations: 'Invitaciones',
      teachers: 'Gestión de profesores',
      'devices-blacklist': 'Dispositivos y lista negra',
      'change-password': 'Cambiar contraseña',
      'game-steps': 'Pasos del juego',
      train: 'Expreso de Hogwarts',
      'train-schedules': 'Horarios del tren',
      requirements: 'Útiles escolares',
      'year-game': 'Juego anual',
      'game-missions': 'Misiones del juego anual',
      persons: 'Journey / Tag',
      'test-results': 'Resultados de pruebas',
      'diagon-alley': 'Gestión del Callejón Diagon',
      'landing-content': 'Contenido de la página principal',
      'about-content': 'Contenido de la página del recorrido',
      faq: 'Preguntas frecuentes (FAQ)',
      'journey-video': 'Video de introducción',
      'site-nav': 'Menú de encabezado/pie de página',
      'sms-templates': 'Plantillas de SMS',
      'site-messages': 'Mensajes del sitio',
      blog: 'Gestión del blog',
      'forum-moderation': 'Moderación del foro',
      'support-tickets': 'Correo de lechuza (soporte)',
      'contact-messages': 'Mensajes de contacto',
      'feature-requests': 'Solicitudes de funciones',
      'error-monitor': 'Monitor de errores',
      'request-logs': 'Solicitudes del servidor',
      'gringotts-bank': 'Banco Gringotts',
      'chat-logs': 'Chats de Dumbledore',
      transactions: 'Libro de transacciones',
      'sms-logs': 'Registros de SMS',
      'registration-settings': 'Configuración general',
      'languages-settings': 'Configuración de idiomas/subdominios',
      'ai-settings': 'Configuración de IA',
      'payment-settings': 'Configuración de pagos',
      'sms-settings': 'Configuración de SMS',
      'email-settings': 'Configuración de correo',
      'telegram-bot': 'Bot de Telegram',
      'birthday-settings': 'Configuración de saludos de cumpleaños',
      backup: 'Copia de seguridad de la base de datos',
      'analytics-tracking': 'Gestor de etiquetas/análisis',
    },
  },
  fr: {
    appTitle: 'Communauté Potterheads',
    dashboardFallback: 'Tableau de bord',
    adminRole: 'Admin',
    teacherRole: 'Enseignant',
    logout: 'Déconnexion',
    brand: 'Poudlard',
    groups: {
      'dashboard-group': 'Tableau de bord et analytique',
      'users-group': 'Utilisateurs et accès',
      'game-group': 'Jeu et aventure',
      'diagon-alley-group': 'Chemin de Traverse',
      'content-group': 'Communication et contenu',
      'support-group': 'Support et retours',
      'monitoring-group': 'Surveillance et journaux',
      'system-group': 'Paramètres système',
    },
    items: {
      dashboard: 'Tableau de bord',
      analytics: 'Analyse des visites',
      'security-logs': 'Activités suspectes',
      users: 'Utilisateurs',
      waitlist: "Liste d'attente",
      invitations: 'Invitations',
      teachers: 'Gestion des enseignants',
      'devices-blacklist': 'Appareils et liste noire',
      'change-password': 'Changer le mot de passe',
      'game-steps': 'Étapes du jeu',
      train: 'Poudlard Express',
      'train-schedules': 'Horaires du train',
      requirements: 'Fournitures scolaires',
      'year-game': 'Jeu annuel',
      'game-missions': 'Missions du jeu annuel',
      persons: 'Journey / Tag',
      'test-results': 'Résultats des tests',
      'diagon-alley': 'Gestion du Chemin de Traverse',
      'landing-content': "Contenu de la page d'accueil",
      'about-content': 'Contenu de la page de parcours',
      faq: 'Foire aux questions (FAQ)',
      'journey-video': "Vidéo d'introduction",
      'site-nav': 'Menu en-tête/pied de page',
      'sms-templates': 'Modèles de SMS',
      'site-messages': 'Messages du site',
      blog: 'Gestion du blog',
      'forum-moderation': 'Modération du forum',
      'support-tickets': 'Courrier des hiboux (support)',
      'contact-messages': 'Messages de contact',
      'feature-requests': 'Demandes de fonctionnalités',
      'error-monitor': "Moniteur d'erreurs",
      'request-logs': 'Requêtes serveur',
      'gringotts-bank': 'Banque Gringotts',
      'chat-logs': 'Discussions avec Dumbledore',
      transactions: 'Registre des transactions',
      'sms-logs': 'Journaux SMS',
      'registration-settings': 'Paramètres généraux',
      'languages-settings': 'Paramètres langues/sous-domaines',
      'ai-settings': "Paramètres de l'IA",
      'payment-settings': 'Paramètres de paiement',
      'sms-settings': 'Paramètres SMS',
      'email-settings': 'Paramètres e-mail',
      'telegram-bot': 'Bot Telegram',
      'birthday-settings': "Paramètres des vœux d'anniversaire",
      backup: 'Sauvegarde de la base de données',
      'analytics-tracking': "Gestionnaire de balises/analytique",
    },
  },
  it: {
    appTitle: 'Comunità Potterheads',
    dashboardFallback: 'Dashboard',
    adminRole: 'Admin',
    teacherRole: 'Insegnante',
    logout: 'Disconnetti',
    brand: 'Hogwarts',
    groups: {
      'dashboard-group': 'Dashboard e analisi',
      'users-group': 'Utenti e accessi',
      'game-group': 'Gioco e avventura',
      'diagon-alley-group': 'Diagon Alley',
      'content-group': 'Comunicazione e contenuti',
      'support-group': 'Supporto e feedback',
      'monitoring-group': 'Monitoraggio e log',
      'system-group': 'Impostazioni di sistema',
    },
    items: {
      dashboard: 'Dashboard',
      analytics: 'Analisi delle visite',
      'security-logs': 'Attività sospette',
      users: 'Utenti',
      waitlist: "Lista d'attesa",
      invitations: 'Inviti',
      teachers: 'Gestione insegnanti',
      'devices-blacklist': 'Dispositivi e lista nera',
      'change-password': 'Cambia password',
      'game-steps': 'Fasi del gioco',
      train: 'Hogwarts Express',
      'train-schedules': 'Orari dei treni',
      requirements: 'Materiale scolastico',
      'year-game': 'Gioco annuale',
      'game-missions': 'Missioni del gioco annuale',
      persons: 'Journey / Tag',
      'test-results': 'Risultati dei test',
      'diagon-alley': 'Gestione di Diagon Alley',
      'landing-content': 'Contenuto pagina principale',
      'about-content': 'Contenuto pagina del percorso',
      faq: 'Domande frequenti (FAQ)',
      'journey-video': 'Video introduttivo',
      'site-nav': 'Menu intestazione/piè di pagina',
      'sms-templates': 'Modelli SMS',
      'site-messages': 'Messaggi del sito',
      blog: 'Gestione blog',
      'forum-moderation': 'Moderazione forum',
      'support-tickets': 'Posta dei gufi (supporto)',
      'contact-messages': 'Messaggi di contatto',
      'feature-requests': 'Richieste di funzionalità',
      'error-monitor': 'Monitor errori',
      'request-logs': 'Richieste al server',
      'gringotts-bank': 'Banca Gringotts',
      'chat-logs': 'Chat con Silente',
      transactions: 'Registro transazioni',
      'sms-logs': 'Log SMS',
      'registration-settings': 'Impostazioni generali',
      'languages-settings': 'Impostazioni lingue/sottodomini',
      'ai-settings': 'Impostazioni IA',
      'payment-settings': 'Impostazioni di pagamento',
      'sms-settings': 'Impostazioni SMS',
      'email-settings': 'Impostazioni e-mail',
      'telegram-bot': 'Bot Telegram',
      'birthday-settings': 'Impostazioni auguri di compleanno',
      backup: 'Backup del database',
      'analytics-tracking': 'Tag manager/analisi',
    },
  },
  ja: {
    appTitle: 'ポッターヘッズ・コミュニティ',
    dashboardFallback: 'ダッシュボード',
    adminRole: '管理者',
    teacherRole: '講師',
    logout: 'ログアウト',
    brand: 'ホグワーツ',
    groups: {
      'dashboard-group': 'ダッシュボードと分析',
      'users-group': 'ユーザーとアクセス',
      'game-group': 'ゲームと冒険',
      'diagon-alley-group': 'ダイアゴン横丁',
      'content-group': 'コミュニケーションとコンテンツ',
      'support-group': 'サポートとフィードバック',
      'monitoring-group': 'モニタリングとログ',
      'system-group': 'システム設定',
    },
    items: {
      dashboard: 'ダッシュボード',
      analytics: '訪問分析',
      'security-logs': '不審な活動',
      users: 'ユーザー',
      waitlist: '待機リスト',
      invitations: '招待状',
      teachers: '講師管理',
      'devices-blacklist': 'デバイスとブラックリスト',
      'change-password': 'パスワード変更',
      'game-steps': 'ゲームステップ',
      train: 'ホグワーツ特急',
      'train-schedules': '列車の時刻表',
      requirements: '学用品',
      'year-game': '年間ゲーム',
      'game-missions': '年間ゲームミッション',
      persons: 'Journey / Tag',
      'test-results': 'テスト結果',
      'diagon-alley': 'ダイアゴン横丁管理',
      'landing-content': 'トップページのコンテンツ',
      'about-content': 'ジャーニーページのコンテンツ',
      faq: 'よくある質問 (FAQ)',
      'journey-video': '導入ビデオ',
      'site-nav': 'ヘッダー/フッターメニュー',
      'sms-templates': 'SMSテンプレート',
      'site-messages': 'サイトメッセージ',
      blog: 'ブログ管理',
      'forum-moderation': 'フォーラムモデレーション',
      'support-tickets': 'ふくろう郵便(サポート)',
      'contact-messages': 'お問い合わせメッセージ',
      'feature-requests': '機能リクエスト',
      'error-monitor': 'エラーモニター',
      'request-logs': 'サーバーリクエスト',
      'gringotts-bank': 'グリンゴッツ銀行',
      'chat-logs': 'ダンブルドアとのチャット',
      transactions: '取引台帳',
      'sms-logs': 'SMSログ',
      'registration-settings': '一般設定',
      'languages-settings': '言語/サブドメイン設定',
      'ai-settings': 'AI設定',
      'payment-settings': '支払い設定',
      'sms-settings': 'SMS設定',
      'email-settings': 'メール設定',
      'telegram-bot': 'Telegramボット',
      'birthday-settings': '誕生日メッセージ設定',
      backup: 'データベースバックアップ',
      'analytics-tracking': 'タグマネージャー/分析',
    },
  },
  ko: {
    appTitle: '포터헤즈 커뮤니티',
    dashboardFallback: '대시보드',
    adminRole: '관리자',
    teacherRole: '교사',
    logout: '로그아웃',
    brand: '호그와트',
    groups: {
      'dashboard-group': '대시보드 및 분석',
      'users-group': '사용자 및 접근 권한',
      'game-group': '게임 및 모험',
      'diagon-alley-group': '다이애건 앨리',
      'content-group': '커뮤니케이션 및 콘텐츠',
      'support-group': '지원 및 피드백',
      'monitoring-group': '모니터링 및 로그',
      'system-group': '시스템 설정',
    },
    items: {
      dashboard: '대시보드',
      analytics: '방문 분석',
      'security-logs': '의심스러운 활동',
      users: '사용자',
      waitlist: '대기자 명단',
      invitations: '초대장',
      teachers: '교사 관리',
      'devices-blacklist': '기기 및 블랙리스트',
      'change-password': '비밀번호 변경',
      'game-steps': '게임 단계',
      train: '호그와트 급행열차',
      'train-schedules': '열차 시간표',
      requirements: '학용품',
      'year-game': '연간 게임',
      'game-missions': '연간 게임 미션',
      persons: 'Journey / Tag',
      'test-results': '시험 결과',
      'diagon-alley': '다이애건 앨리 관리',
      'landing-content': '홈페이지 콘텐츠',
      'about-content': '여정 페이지 콘텐츠',
      faq: '자주 묻는 질문 (FAQ)',
      'journey-video': '소개 영상',
      'site-nav': '헤더/푸터 메뉴',
      'sms-templates': 'SMS 템플릿',
      'site-messages': '사이트 메시지',
      blog: '블로그 관리',
      'forum-moderation': '포럼 관리',
      'support-tickets': '부엉이 우편함 (지원)',
      'contact-messages': '문의 메시지',
      'feature-requests': '기능 요청',
      'error-monitor': '오류 모니터',
      'request-logs': '서버 요청',
      'gringotts-bank': '그린고츠 은행',
      'chat-logs': '덤블도어와의 대화',
      transactions: '거래 원장',
      'sms-logs': 'SMS 로그',
      'registration-settings': '일반 설정',
      'languages-settings': '언어/서브도메인 설정',
      'ai-settings': 'AI 설정',
      'payment-settings': '결제 설정',
      'sms-settings': 'SMS 설정',
      'email-settings': '이메일 설정',
      'telegram-bot': '텔레그램 봇',
      'birthday-settings': '생일 축하 설정',
      backup: '데이터베이스 백업',
      'analytics-tracking': '태그 매니저/분석',
    },
  },
  pt: {
    appTitle: 'Comunidade Potterheads',
    dashboardFallback: 'Painel',
    adminRole: 'Admin',
    teacherRole: 'Professor',
    logout: 'Sair',
    brand: 'Hogwarts',
    groups: {
      'dashboard-group': 'Painel e análises',
      'users-group': 'Usuários e acessos',
      'game-group': 'Jogo e aventura',
      'diagon-alley-group': 'Beco Diagonal',
      'content-group': 'Comunicação e conteúdo',
      'support-group': 'Suporte e feedback',
      'monitoring-group': 'Monitoramento e logs',
      'system-group': 'Configurações do sistema',
    },
    items: {
      dashboard: 'Painel',
      analytics: 'Análise de visitas',
      'security-logs': 'Atividades suspeitas',
      users: 'Usuários',
      waitlist: 'Lista de espera',
      invitations: 'Convites',
      teachers: 'Gestão de professores',
      'devices-blacklist': 'Dispositivos e lista negra',
      'change-password': 'Alterar senha',
      'game-steps': 'Etapas do jogo',
      train: 'Expresso de Hogwarts',
      'train-schedules': 'Horários do trem',
      requirements: 'Material escolar',
      'year-game': 'Jogo anual',
      'game-missions': 'Missões do jogo anual',
      persons: 'Journey / Tag',
      'test-results': 'Resultados dos testes',
      'diagon-alley': 'Gestão do Beco Diagonal',
      'landing-content': 'Conteúdo da página inicial',
      'about-content': 'Conteúdo da página de jornada',
      faq: 'Perguntas frequentes (FAQ)',
      'journey-video': 'Vídeo de introdução',
      'site-nav': 'Menu de cabeçalho/rodapé',
      'sms-templates': 'Modelos de SMS',
      'site-messages': 'Mensagens do site',
      blog: 'Gestão do blog',
      'forum-moderation': 'Moderação do fórum',
      'support-tickets': 'Correio-coruja (suporte)',
      'contact-messages': 'Mensagens de contato',
      'feature-requests': 'Solicitações de recursos',
      'error-monitor': 'Monitor de erros',
      'request-logs': 'Solicitações do servidor',
      'gringotts-bank': 'Banco Gringotes',
      'chat-logs': 'Conversas com Dumbledore',
      transactions: 'Livro de transações',
      'sms-logs': 'Registros de SMS',
      'registration-settings': 'Configurações gerais',
      'languages-settings': 'Configurações de idiomas/subdomínios',
      'ai-settings': 'Configurações de IA',
      'payment-settings': 'Configurações de pagamento',
      'sms-settings': 'Configurações de SMS',
      'email-settings': 'Configurações de e-mail',
      'telegram-bot': 'Bot do Telegram',
      'birthday-settings': 'Configurações de felicitações de aniversário',
      backup: 'Backup do banco de dados',
      'analytics-tracking': 'Gerenciador de tags/análises',
    },
  },
};
